import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const PaymentHistoryLazy = lazyLoader(
  () => import('./PaymentHistory' /* webpackChunkName: "payment-history" */),
);

const PaymentHistory = () => {
  return (
    <Suspense fallback={null}>
      <PaymentHistoryLazy />
    </Suspense>
  );
};

export default PaymentHistory;
